import React from "react";
import { useHistory } from "react-router-dom";
import { useProfitAuthActions } from "../auth/ProfitAuthContext";
import { profitPortalMeta } from "../data/profitData";

const PROFIT_LOGO_URL = process.env.PUBLIC_URL + "/merchant-login-logo.webp";

export default function ProfitLoginPage() {
  const history = useHistory();
  const { login } = useProfitAuthActions();
  const [email, setEmail] = React.useState(profitPortalMeta.loginEmail);
  const [password, setPassword] = React.useState(profitPortalMeta.loginPassword);

  function handleSubmit(event) {
    event.preventDefault();
    login({ email });
    history.push("/profit/dashboard");
  }

  return (
    <div className="profit-shell profit-login-shell">
      <div className="profit-login-wrap">
        <div className="profit-login-brand">
          <img className="profit-logo-image profit-logo-image-large" src={PROFIT_LOGO_URL} alt="Uniweb" />
          <div className="profit-login-brand-name">Uniweb Pte. Ltd.</div>
          <div className="profit-login-brand-tag">Partner Portal</div>
        </div>
        <form className="profit-login-card" onSubmit={handleSubmit}>
          <div className="profit-login-title">Welcome back</div>
          <div className="profit-login-subtitle">
            Sign in to your partner account to continue.
          </div>
          <div className="profit-form-group">
            <label className="profit-form-label" htmlFor="profit-email">
              Email Address
            </label>
            <input
              id="profit-email"
              className="profit-form-input"
              type="email"
              value={email}
              onChange={function handleEmailChange(event) {
                setEmail(event.target.value);
              }}
            />
          </div>
          <div className="profit-form-group">
            <label className="profit-form-label" htmlFor="profit-password">
              Password
            </label>
            <input
              id="profit-password"
              className="profit-form-input"
              type="password"
              value={password}
              onChange={function handlePasswordChange(event) {
                setPassword(event.target.value);
              }}
            />
          </div>
          <button className="profit-login-button" type="submit">
            Sign In →
          </button>
          <div className="profit-login-footer">
            © 2026 Uniweb Pte. Ltd.
            <br />
            {profitPortalMeta.licenseText}
          </div>
        </form>
        <div className="profit-login-meta">
          All connections are encrypted and secured
        </div>
      </div>
    </div>
  );
}
